import { en } from "./en.js";
import { es } from "./es.js";
import { pt } from "./pt.js";
export const registerTranslations = {
    en,
    es,
    pt,
};
//# sourceMappingURL=translations.js.map